import React, { HTMLAttributeAnchorTarget } from 'react';
import { PublicArrowRightTail } from 'notta-web-icon';
import * as styles from './index.module.less';

interface IProps {
  link: string;
  target?: HTMLAttributeAnchorTarget;
  size: 'small' | 'medium';
  disable?: boolean;
  className?: string;
  children?: any;
  onClick?: () => void;
}

const ButtonWithArrow = ({ size, link, target = '_self', className, disable = false, children }: IProps) => {
  return (
    <div className={`${styles.btn_container} ${disable && styles.disable_btn_container} ${className}`}>
      <a href={link} target={target} className={disable && styles.disable_link}>
        <div
          className={`${size === 'small' ? styles.small_btn_container : styles.medium_btn_container} ${
            styles.common_btn_container
          }`}
        >
          {children} <PublicArrowRightTail />
        </div>
      </a>
    </div>
  );
};
export default ButtonWithArrow;
